import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);
const sweet = (title, text, icon) => { MySwal.fire({ title, text, icon, confirmButtonColor: 'var(--color-primario)' }) }

export const UseSweetAlert = (title, text, icon) => {
  return (
    sweet(title, text, icon)
  )
}
